import React from 'react';
import styled from 'styled-components';
import LinkPreview from './LinkPreview';

const ImageContainer = styled.div`
  border: 1px solid ${props => props.theme.colors.neutral4};
  border-radius: 12px;
`;

const StyledImage = styled.img`
  object-fit: contain;
  max-width: 100%;
  max-height: 90vh;
  border-radius: 12px;
  position: relative;
  border-radius: ${props =>
    props.linkPreviewData ? '12px 12px 0 0' : props.theme.borderRadius.xl};
`;

const Image = props => {
  const { picture, linkPreviewData = {} } = props;

  return (
    <ImageContainer>
      {picture && (
        <StyledImage linkPreviewData={!!linkPreviewData.url} src={picture} />
      )}
      {linkPreviewData.url && <LinkPreview {...linkPreviewData} />}
    </ImageContainer>
  );
};

export default Image;
